<div
  #waveformContainer
  class="waveform"
  style="position: relative"
  [ngStyle]="{
    background: trackRendered ? 'transparent' : appService.activeTheme == 'dark' ? '#232323' : '#eaeaea',
    'border-radius': trackRendered ? '0px' : '10px',
  }"
></div>
